<template>
    <div class="detail">
        <Spin fix v-if="is_loading">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
        <div class="bread-menu">
            <div class="bread-item" @click="$router.push({name:'MaterialWearHouse',query:{type:detail.type == 1 ? 'fabric':'accessory'}})">我的{{detail.type == 1 ? '面料' : '辅料'}}库</div>
            <Icon type="ios-arrow-forward" color="#333" size="12px" />
            <div class="bread-item active">{{detail.type == 1 ? '面料' : '辅料'}}信息详情</div>
        </div>
        <div class="info-container">
            <img :src="detail.image|default_img" alt="" class="cover-img" />
            <div class="info-box">
                <div class="info-title-box">
                    <div class="info-title">
                        <div class="title-row">
                            <div class="title">{{detail.name}}</div>
                            <div :class="['status',{'has-in':detail.warehouse_status,'not-in':!detail.warehouse_status}]">{{ detail.warehouse_status ? '已入仓' : '未入仓' }}</div>
                        </div>
                        <div class="time-row">创建时间 {{detail.create_time}}</div>
                    </div>
                    <div class="operate-box">
                        <img src="../../assets/images/material-wear-house/icon-edit.png" alt="" class="operate-item" @click="show_add_material=true" />
                        <img src="../../assets/images/material-wear-house/icon-delete.png" alt="" class="operate-item" @click="onDeleteMaterial(detail)"/>
                    </div>
                </div>
                <div class="main-info-box">
                    <div class="row-1-col">
                        <div class="label">编号:</div>
                        <div class="value">{{detail.no}}</div>
                    </div>
                    <div class="row-2-col" v-if="detail.type == 1">
                        <div class="col-item">
                            <div class="label">幅宽:</div>
                            <div class="value">{{detail.wide_width}}</div>
                        </div>
                        <div class="col-item">
                            <div class="label">克重:</div>
                            <div class="value">{{detail.weight}}</div>
                        </div>
                    </div>
                    <div class="row-1-col">
                        <div class="label">成分:</div>
                        <div class="value">{{detail.component}}</div>
                    </div>
                    <div class="row-color">
                        <div class="label">颜色:</div>
                        <div class="value">
                            <div v-for="(item,index) in detail.color" :key="`value-item-${index}`" :class="['value-item',{active:item.uuid == curr_color.uuid}]" @click="onColorSelect(item)">
                                <img v-viewer :src="detail.image|default_img" alt="" class="color-img" />
                                {{detail.name}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="stock-box">
                    <div class="stock-row">
                        <div class="label">库存:</div>
                        <div class="value">{{ curr_color.stock ? curr_color.stock : '-' }}</div>
                    </div>
                    <div class="push-in-btn" @click="show_material_in=true">
                        <img src="../../assets/images/material-wear-house/icon-trunk-white.png" alt="" class="btn-icon" />
                        入仓
                    </div>
                </div>
            </div>
        </div>
        <div class="log-container">
            <div class="log-top">
                <div class="tab-list">
                    <div v-for="(item,index) in tab_list" :key="`tab-${index}`" :class="['tab-item',{active:curr_tab == item.value}]" @click="curr_tab = item.value">{{item.name}}</div>
                </div>
                <div class="filter-box">
                    <div class="time-filter">
                        全部时间 <Icon type="ios-arrow-down" color="#666" size="14px" />
                    </div>
                    <div class="search-box">
                        <Icon type="ios-search" color="#999" size="18" /><input type="text" placeholder="搜索记录" />
                    </div>
                </div>
            </div>
            <div :class="['log-list',{'empty-mode':!list.length}]">
                <div v-if="!list.length" class="empty-data">
                    <div class="main-text">暂无记录~</div>
                    <div class="desc-text">还在为找面料浪费时间？自己库存混乱、盘点繁琐？入仓后，全链路数字化，让管理一目了然，</div>
                    <div class="desc-text">定制时直接调用，告别反复寄样</div>
                </div>
                <table v-else>
                    <thead>
                        <template v-if="curr_tab == 'in'">
                            <tr>
                                <th>物流公司</th>
                                <th>物流单号</th>
                                <th>寄出时间</th>
                                <th>入库时间</th>
                                <!-- <th>仓库档案编码</th> -->
                                <th>入库数量(米)</th>
                                <th>实际入库数量(米)</th>
                                <th>状态</th>
                            </tr>
                        </template>
                        <template v-else>
                            <tr>
                                <th>使用订单</th>
                                <th>时间</th>
                                <th>使用颜色</th>
                                <th>使用数量(米)</th>
                            </tr>
                        </template>
                    </thead>
                    <tbody>
                        <template v-if="curr_tab == 'in'">
                            <tr v-for="(item,index) in list" :key="`log-item-${index}`">
                                <td :title="item.logistics_company || '-'">{{item.logistics_company || '-'}}</td>
                                <td :title="item.logistics_no || '-'" >
                                    <span >{{item.logistics_no || '-'}}</span>
                                    <span style="margin-left:10px;cursor:pointer;color:#0d99ff;font-size:12px;" class="detail-btn" @click="viewLogistics(item.logistics_company, item.logistics_no)">查看物流</span>
                                </td>
                                <td :title="item.send_time || '-'">{{item.send_time || '-'}}</td>
                                <td :title="item.check_time || '-'">{{item.check_time || '-'}}</td>
                                <!-- <td>-</td> -->
                                <td>
                                    <div class="in-num-box">
                                        {{item.user_send_total}}米 
                                        <Poptip trigger="hover" placement="bottom">
                                            <template #content>
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>面料颜色</th>
                                                            <th>库存数量(m)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(color,ci) in item.wuliao_json" :key="`color-index-${ci}`">
                                                            <td>
                                                                <div class="color-val">
                                                                    <img :src="color.image|default_img" alt="" class="color-img">{{color.name}}
                                                                </div>
                                                            </td>
                                                            <td>{{color.real}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </template>
                                            <div class="detail-btn">详情</div>
                                        </Poptip>
                                    </div>
                                </td>
                                <td>
                                    <div class="in-num-box">
                                        {{item.real_send_total}}米 
                                        <Poptip trigger="hover" placement="bottom">
                                            <template #content>
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>面料颜色</th>
                                                            <th>库存数量(m)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(color,ci) in item.wuliao_json" :key="`color-index-real-${ci}`">
                                                            <td>
                                                                <div class="color-val">
                                                                    <img :src="color.image|default_img" alt="" class="color-img">{{color.name}}
                                                                </div>
                                                            </td>
                                                            <td>{{color.real}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </template>
                                            <div class="detail-btn">详情</div>
                                        </Poptip>
                                    </div>
                                </td>
                                <td>{{ item.status == 1?'已入库':'已寄出' }}</td>
                            </tr>
                        </template>
                        <template v-else>
                            <tr v-for="(item,index) in list" :key="`log-item-${index}`"> 
                                <td :title="item.order_no || '-'">{{ item.order_no || '-' }}</td>
                                <td :title="item.create_time || '-'">{{ item.create_time || '-' }}</td>
                                <td :title="item.color_name || '-'">
                                    <div class="color-col">
                                        <img :src="item.color_image | default_img" v-viewer alt="" class="color-img">{{item.color_name || '-'}}
                                    </div>
                                </td>
                                <td :title="item.consumption">{{ item.consumption || '-' }}米</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <add-material v-if="show_add_material" @close="onClose" :material="detail" :type="detail.type" />
        <material-in v-if="show_material_in" @close="onClose" :material="detail" />
        <Modal
            v-model="logisticsTrackingVisible"
            title="物流轨迹"
            footer-hide
            width="1100"
            :styles="{ top: '80px' }"
        >
            <logistics-tracking
                :logistics_name="logisticsData.logistics_name"
                :logistics_no="logisticsData.logistics_no"
                :tracking-list="logisticsData.trackingList"
            />
        </Modal>
    </div>
</template>
<script>
import { DeleteOwnerMaterial, GetOwnerMaterialDetail, OwnerMaterialInLog, OwnerMaterialUseLog,GetLogisticsTracking } from '@/api/index';
import AddMaterial from './components/AddMaterial.vue';
import MaterialIn from './components/MaterialIn.vue';
import LogisticsTracking from '@/components/LogisticsTracking.vue';
export default{
    components:{
        AddMaterial,MaterialIn,LogisticsTracking
    },
    data(){
        return{
            tab_list:[
                {name:'入仓记录',value:'in'},
                {name:'使用记录',value:'use'},
            ],
            curr_tab:'in',
            // curr_color:1,
            list:[{}],
            detail:{},
            curr_color:{},
            is_loading:false,
            query_log:{
                page:1,
                limit:10,
                uuid:''
            },
            show_add_material:false,
            show_material_in:false,
            logisticsTrackingVisible:false,
            logisticsData:{
                logistics_name:'',
                logistics_no:'',
                trackingList:[]
            }
        }
    },
    watch:{
        curr_tab(news,olds){
            this.onGetLogList();
        }
    },
    mounted(){
        this.query_log.uuid = this.$route.query.uuid;
        Promise.all([
            this.onGetDetail(),
            this.onGetLogList()
        ])
    },
    methods:{
         viewLogistics(logistics_name, logistics_no){
            this.logisticsTrackingVisible = true;
            this.logisticsData = {
                logistics_name,
                logistics_no,
                trackingList: []
            };
            GetLogisticsTracking({ logistics_no, logistics_name }).then(res=>{
                if(res.data){
                    this.logisticsData = {
                        logistics_name: res.data.logistics_name || logistics_name,
                        logistics_no: res.data.logistics_no || logistics_no,
                        trackingList: res.data.traceList || []
                    };
                }
            }).catch(e=>{
                console.log('err-logistics-tracking', e);
            });
        },
        async onDeleteMaterial({uuid}){
            try{
                const {code,msg} = await DeleteOwnerMaterial({uuid});
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('操作成功~');
                this.$router.back();
            }catch(e){
                console.log('err-delete-material',e);
                this.$layer.msg(e.msg);
            }
        },
        onClose(){
            this.show_stock_detail = false;
            this.show_add_material = false;
            this.show_material_in = false;
            Promise.all([
                this.onGetDetail(),
                this.onGetLogList()
            ])
        },
        async onGetLogList(){
            try{
                let response;
                if(this.curr_tab == 'in'){
                    response = await OwnerMaterialInLog({...this.query_log});
                }else{
                    response = await OwnerMaterialUseLog({...this.query_log});
                }
                const {code,msg,data} = response;
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                // this.list = [{}];
                this.list = data.list || [];
            }catch(e){
                console.log('err-log-list',e);
                this.$layer.msg(e.msg);
            }
        },
        async onGetDetail(){
            try{
                this.is_loading = true;
                const {code,msg,data} = await GetOwnerMaterialDetail({uuid:this.$route.query.uuid});
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                if(!data){
                    this.$layer.msg('查无此物料~');
                    this.$router.back();
                    return;
                }
                this.detail = data;
            }catch(e){
                console.log('err-detail',e);
                this.$layer.msg(e.msg);
            }finally{
                this.is_loading = false;
            }
        },
        onColorSelect(color){
            console.log('color',color);
            this.curr_color = color;
            console.log('curr_color',this.curr_color);
        }
    }
}
</script>
<style lang="scss" scoped>
.demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.demo-spin-col{
    height: 100px;
    position: relative;
    border: 1px solid #eee;
}
.detail{
    width:100%;
    min-height:100%;
    background:#f8f9fb;
    padding:20px 100px 80px 30px;
    position:relative;
    .bread-menu{
        display:flex;
        align-items:center;
        column-gap:8px;
        margin-bottom:19px;
        .bread-item{
            color:#999;
            font-size:14px;
            cursor:pointer;
            &.active,&:hover{
                color:#333;
            }
        }
    }
    .info-container{
        width:100%;
        background:#fff;
        padding:24px;
        display:flex;
        align-items:center;
        column-gap:40px;
        margin-bottom:16px;
        .cover-img{
            width:350px;
            height:350px;
            border:1px solid #e3e3e3;
            border-radius:8px;
            object-fit: cover;
            object-position:center;
        }
        .info-box{
            flex:1;
            display:flex;
            flex-direction:column;
            .info-title-box{
                width:100%;
                border-bottom:1px solid #e3e3e3;
                padding-bottom:12px;
                display:flex;
                align-items:center;
                justify-content: space-between;
                margin-bottom:17px;
                .info-title{
                    display:flex;
                    flex-direction:column;
                    .title-row{
                        display:flex;
                        align-items:center;
                        column-gap:10px;
                        margin-bottom:4px;
                        .title{
                            color:#333;
                            font-size:18px;
                            font-weight:bold;
                        }
                        .status{
                            font-size:12px;
                            padding:1px 8px;
                            border-radius:20px;
                            &.has-in{
                                background:#e6f9f0;
                                color:#02c160;
                            }
                            &.not-in{
                                background:#e8e9eb;
                                color:#666;
                            }
                        }
                    }
                    .time-row{
                        color:#999;
                        font-size:12px;
                    }
                }
                .operate-box{
                    display:flex;
                    align-items:center;
                    column-gap:16px;
                    .operate-item{
                        width:22px;
                        height:22px;
                        cursor:pointer;
                    }
                }
            }
            .main-info-box{
                width:100%;
                padding-bottom:16px;
                margin-bottom:18px;
                border-bottom:1px solid #e3e3e3;
                display:flex;
                flex-direction: column;
                row-gap:10px;
                .row-1-col{
                    display:flex;
                    align-items:center;
                    column-gap:4px;
                    .label{
                        color:#666;
                        font-size:12px;
                    }
                    .value{
                        color:#333;
                        font-size:14px;
                    }
                }
                .row-2-col{
                    display:flex;
                    align-items:center;
                    column-gap:60px;
                    .col-item{
                        display:flex;
                        align-items:center;
                        column-gap:4px;
                        .label{
                            color:#666;
                            font-size:12px;
                        }
                        .value{
                            color:#333;
                            font-size:14px;
                        }
                    }
                }
                .row-color{
                    display:flex;
                    align-items:flex-start;
                    column-gap:4px;
                    .label{
                        color:#666;
                        font-size:12px;
                        flex-shrink:0;
                    }
                    .value{
                        display:flex;
                        flex-wrap:wrap;
                        gap:10px;
                        .value-item{
                            border:1px solid #e3e3e3;
                            border-radius:4px;
                            display:flex;
                            align-items:center;
                            column-gap:7px;
                            padding:6px;
                            cursor:pointer;
                            color:#333;
                            font-size:14px;
                            &.active{
                                border:1px solid #ff5967;
                            }
                            .color-img{
                                width:28px;
                                height:28px;
                                border:1px solid #e3e3e3;
                                border-radius:4px;
                            }
                        }
                    }
                }
            }
            .stock-box{
                width:100%;
                display:flex;
                flex-direction:column;
                .stock-row{
                    display:flex;
                    align-items:center;
                    column-gap:4px;
                    margin-bottom:34px;
                    .label{
                        color:#666;
                        font-size:12px;
                    }
                    .value{
                        color:#333;
                        font-size:14px;
                    }
                }
                .push-in-btn{
                    background:#ff5967;
                    border-radius:4px;
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    column-gap:6px;
                    color:#fff;
                    font-size:14px;
                    font-weight:bold;
                    cursor:pointer;
                    // padding:9px 47px;
                    width:150px;
                    height:40px;
                    .btn-icon{
                        width:22px;
                        height:22px;
                    }
                }
            }
        }
    }
    .log-container{
        width:100%;
        min-height:701px;
        background:#fff;
        padding:20px 24px;
        display:flex;
        flex-direction:column;
        .log-top{
            width:100%;
            padding-bottom:13px;
            border-bottom:1px solid #e3e3e3;
            display:flex;
            align-items:center;
            justify-content:space-between;
            .tab-list{
                display:flex;
                align-items:center;
                column-gap:40px;
                .tab-item{
                    color:#666;
                    font-size:16px;
                    cursor:pointer;
                    &.active{
                        color:#1a1a1a;
                        font-size:18px;
                        font-weight:bold;
                        position:relative;
                        &::after{
                            content:"";
                            width:100%;
                            height:3px;
                            background:#ff5967;
                            display:block;
                            position:absolute;
                            bottom:-17px;
                            left:0;

                        }
                    }
                }
            }
            .filter-box{
                display:flex;
                align-items:center;
                column-gap:14px;
                height:34px;
                .time-filter{
                    width:fit-content;
                    height:100%;
                    padding:0 16px;
                    border:1px solid #e3e3e3;
                    border-radius:4px;
                    display:flex;
                    align-items:center;
                    column-gap:10px;
                    color:#666;
                    font-size:14px;
                }
                .search-box{
                    width:189px;
                    height:100%;
                    border:1px solid #e3e3e3;
                    border-radius:4px;
                    display:flex;
                    align-items:center;
                    column-gap:10px;
                    padding:0 16px;
                    input{
                        border:none;
                        outline:none;
                        width:80%
                    }
                }
            }
        }
        .log-list{
            flex:1;
            &.empty-mode{
                display:flex;
            }
            
            .empty-data{
                width:100%;
                min-height:100%;
                display:flex;
                align-items:center;
                justify-content:center;
                flex-direction:column;
                .main-text{
                    color:#666;
                    font-size:16px;
                    margin-bottom:16px;
                }
                .desc-text{
                    color:#999;
                    font-size:14px;
                }
            }
            table{
                width:100%;
                border-collapse: collapse;
                table-layout:fixed;
                margin-top:22px;
                thead tr{
                    background:#edeff2;
                    height:48px;
                    user-select:none;
                    th{
                        text-align:center;
                        color:#333;
                        font-size:14px;
                        white-space:nowrap;
                        text-overflow:ellipsis;
                        overflow:hidden;
                    }
                }
                tbody tr{
                    height:48px;
                    border-bottom:1px solid #e3e3e3;
                    td{
                        text-align:center;
                        line-height:1.5;
                        white-space:nowrap;
                        text-overflow:ellipsis;
                        overflow:hidden;
                        .in-num-box{
                            display:flex;
                            align-items:center;
                            justify-content:center;
                            column-gap:8px;
                            .detail-btn{
                                color:#0d99ff;
                                cursor:pointer;
                                font-size:12px;
                            }
                            table{
                                border-collapse: collapse;
                                table-layout:fixed;
                                width:320px;
                                tr{
                                    border:1px solid #e3e3e3;
                                    height:32px;
                                }
                                td,th{
                                    text-align:center;
                                    .color-val{
                                        display:flex;
                                        align-items:center;
                                        column-gap:7px;
                                        color:#333;
                                        font-size:14px;
                                        padding:5px 13px;
                                        .color-img{
                                            width:32px;
                                            height:32px;
                                            border:1px solid #e3e3e3;
                                            border-radius:4px;
                                        }
                                    }
                                }
                                thead tr{
                                    background:#f6f7fa;
                                }
                            }
                        }
                        .color-col{
                            display:flex;
                            align-items:center;
                            justify-content:center;
                            column-gap:10px;
                            color:#333;
                            font-size:14px;
                            .color-img{
                                width:28px;
                                height:28px;
                                border:1px solid #e3e3e3;
                                border-radius:4px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>